import { wrapFromClient } from './component-wrapper'
import buildAlertModalSpy from './alert-modal-spy'

export const test = {
  wrapFromClient,
  buildAlertModalSpy
}
